export default {
  title: 'Nebula buds AI การโทร', // "Nebula buds AI通话" 翻译为泰语
  userID: 'รหัสผู้ใช้ : ', // "用户ID : "
  hurryUp: 'รอการโทรจากฝ่ายตรงข้าม', // "等待对方呼叫"
  waitingCall: 'รอการโทรจากฝ่ายตรงข้ามในหน้านี้ กรุณาอย่าปิดหน้านี้ก่อนเวลาอันควร', // "在此页面等待对方拨打电话，请勿提前关闭。"
  subSwitch: 'สวิตช์คำบรรยาย', // "字幕开关"
  initWait: 'รอการเริ่มต้น', // "等待初始化"
  initSuccess: 'การเริ่มต้นเสร็จสิ้น รอการโทรจากฝ่ายตรงข้าม กรุณาอย่าปิดหน้านี้!', // "初始化完成，等待对方呼叫。请勿关闭页面！"
  callStart: 'การโทรเชื่อมต่อ', // "电话接通"
  callEnd: 'การโทรสิ้นสุด', // "通话结束"
  careful: 'ระวัง : ', // "注意 : "
  wait: 'ส่วนประกอบการโทรพร้อมแล้ว รอการโทรจากฝ่ายตรงข้าม', // "通话组件已准备好,等待对方拨打电话"
  langSwitch: {
    ar: 'อารบิก', // "阿拉伯语"
    da: 'เดนมาร์ก', // "丹麦语"
    de: 'เยอรมัน', // "德语"
    en: 'อังกฤษ', // "英语"
    es: 'สเปน', // "西班牙语"
    fil: 'ฟิลิปปินส์', // "菲律宾语"
    fr: 'ฝรั่งเศส', // "法语"
    hi: 'ฮินดี', // "印地语"
    id: 'อินโดนีเซีย', // "印度尼西亚语"
    it: 'อิตาลี', // "意大利语"
    ja: 'ญี่ปุ่น', // "日文"
    ko: 'เกาหลี', // "韩语"
    ms: 'มาเลเซีย', // "马来语"
    no: 'นอร์เวย์', // "挪威语"
    pt: 'โปรตุเกส', // "葡萄牙语"
    ru: 'รัสเซีย', // "俄语"
    sv: 'สวีเดน', // "瑞典语"
    th: 'ไทย', // "泰语"
    tr: 'ตุรกี', // "土耳其语"
    vi: 'เวียดนาม', // "越南语"
    zh: 'จีน' // "中文"
  }
}
